import { render } from "./cell_json_modal.vue?vue&type=template&id=844e53f2"
import script from "./cell_json_modal.vue?vue&type=script&lang=ts"
export * from "./cell_json_modal.vue?vue&type=script&lang=ts"
script.render = render

export default script